import { IEntity } from '../interfaces/entity';
import { LookupType } from './lookup-type';
import { Relationship } from './relationship';
import { SubjectType } from './subject-type';

export interface ILookupList{
  items: Lookup[];
  totalCount: number;
}

export class Lookup implements IEntity {
  id: number;
  uid: string;
  description: string;
  onlineReporting: boolean;
  deadlineDays:number;
  hideRecord: boolean;
  lookupTypeId: number;
  lookupType: LookupType;
  canDelete: boolean;
  categories: string;
  lookupCategories: LookupCategory[];
}

// tslint:disable-next-line: max-classes-per-file
export class LookupCategory{
  id: number;
  lookupId: number;
  lookup: Lookup;
  categoryId: number;
  category: Category;

  constructor(lookupCategory?){
    lookupCategory = lookupCategory || {};
    this.id = lookupCategory.id;
    this.lookupId = lookupCategory.lookupId;
    this.lookup = lookupCategory.lookup;
    this.categoryId = lookupCategory.categoryId;
    this.category = lookupCategory.category;
  }
}

export interface ICategoryList{
  items: Category[];
  totalCount: number;
}

// tslint:disable-next-line: max-classes-per-file
export class Category implements IEntity {
  id: number;
  uid: string;
  description: string;
  hideRecord: boolean;
  onlineReporting: boolean;
  autoRestrict: boolean;
  subjectTypeId: number;
  subjectType: SubjectType;
  primaryRelationshipId: string;
  primaryRelationship: string;
  categoryUserSecurity: CategoryUserSecurity[];
  lookups: string;
  lookupCategories: LookupCategory[];
  restrictedUsers: string;
  canDelete: boolean;

  constructor(category?){
    category = category || {};
    this.id = category.id;
    this.uid = category.uid;
    this.description = category.description;
    this.hideRecord = category.hideRecord;
    this.autoRestrict = category.autoRestrict;
    this.subjectTypeId = category.subjectTypeId;
    this.subjectType = category.subjectType;
    this.primaryRelationshipId = category.primaryRelationshipId;
    this.primaryRelationship = category.primaryRelationship;
    this.categoryUserSecurity = category.categoryUserSecurity || [];
    this.canDelete = true;
  }
}

// tslint:disable-next-line: max-classes-per-file
export class CategoryUserSecurity {
  id: number;
  categoryId: number;
  userId: number;

  constructor(categoryUserSecurity?){
    categoryUserSecurity = categoryUserSecurity || {};
    this.id = categoryUserSecurity.id;
    this.categoryId = categoryUserSecurity.categoryId;
    this.userId = categoryUserSecurity.userId;
  }
}
